export class DropDownValue {
	value: string;
	representation: string;

	constructor(value: string, representation: string) {
		this.value = value;
		this.representation = representation;
	}
}
